import React, { useEffect, useState } from 'react';
import "./navigationbar.css";
import "./responsive.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import NavBar from './NavBar';
import { NavLink } from 'react-router-dom';
import LargeScreen from './LargeScreen';

const NavigationBar = () => {

  const [openMenu, setOpenMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => {
    const mobile = window.innerWidth < 760;

    setIsMobile(mobile);
    if (!mobile) setOpenMenu(false);
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [])

  return (
    <>
      <nav className="navigation-bar">
        <div className="bar wrap fcb">
          <NavLink className="brand" to="/">
            <span className="prompt">~$</span> chaichengxun
          </NavLink>
          {
            isMobile
            ? <button
                type="button"
                className="hamburger fcc"
                aria-label={openMenu ? "Close menu" : "Open menu"}
                aria-expanded={openMenu}
                onClick={() => setOpenMenu(!openMenu)}
              >
                {openMenu ? <IoClose /> : <GiHamburgerMenu />}
              </button>
            : <LargeScreen />
          }
        </div>
      </nav>
      {/* kept outside <nav> so the overlay is fixed to the viewport and not to
          the bar, whose backdrop-filter would otherwise become its container */}
      {isMobile && <NavBar openMenu={openMenu} setOpenMenu={setOpenMenu} />}
    </>
  )
}

export default NavigationBar
